import type {MessageTree} from "@jantm/model-core";

export const en: MessageTree = {
  model: { car: { field: { licensePlate: 'Car sign' } } },
}
